import { render, staticRenderFns } from "./ModalSelectEntranceStudyCategory.vue?vue&type=template&id=68814ec8&scoped=true&lang=pug&"
import script from "./ModalSelectEntranceStudyCategory.vue?vue&type=script&lang=ts&"
export * from "./ModalSelectEntranceStudyCategory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68814ec8",
  null
  
)

export default component.exports